/*
 * @Author: ningbo.kang
 * @Date: 2019-11-27 14:10:18
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2019-11-27 15:29:20
 * @FilePath: /template/src/api/system/notice.js
 * @Description: 系统消息
 */

import db from '@/api/db';

/**
 * [model 系统消息模块]
 * @type {Object}
 */
const model = {
  /**
   * 通知记录
   * @param {*} param
   */
  getNotice(param) {
    return db.post('/system/tips/notice', param);
  },
  /**
   * 消息记录
   * @param {*} param
   */
  getInformation(param) {
    return db.post('/system/tips/infomation', param);
  },
  /**
   * 待办记录
   * @param {*} param
   */
  getTodo(param) {
    return db.post('/system/tips/todo', param);
  },
  /**
   * 提示总数
   * @param {*} param
   */
  getCount(param) {
    return db.post('/system/tips/count', param);
  },
};

export default model;
